import { render, staticRenderFns } from "./CorrelativeSubjectsPopUp.vue?vue&type=template&id=c5cd6e42&scoped=true"
import script from "./CorrelativeSubjectsPopUp.vue?vue&type=script&lang=js"
export * from "./CorrelativeSubjectsPopUp.vue?vue&type=script&lang=js"
import style0 from "./CorrelativeSubjectsPopUp.vue?vue&type=style&index=0&id=c5cd6e42&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5cd6e42",
  null
  
)

export default component.exports